import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { secondaryMarketDlpProductFetchRequested } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.actions';
import { getKeyCode } from 'state/secondaryMarket/utils';
import type { EpicWithThunk } from 'state/state.common';
import { getProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.selector';
export function loadAfterDlpFormTabContentFetchedEpic(): EpicWithThunk {
  return (actions$, state$) => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'dlpProducts'),
      withLatestFrom(state$),
      mergeMap(([{ tabId }, state]) => {
        const productKey = getProductKey(state, tabId);
        const isin = getKeyCode(productKey)!;
        const actions: Action[] = [secondaryMarketDlpProductFetchRequested(isin, tabId)];
        return of(...actions);
      }),
    );
  };
}
